import Axios from 'axios';
import {urlTest} from '../config/properties';

export default () => {
    return Axios.create({
        baseURL: urlTest
    })
}